
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AnalyzerSelectionItem',
  props: {
    name: {
      type: String,
      required: true
    },
    shortcode: {
      type: String,
      default: ''
    },
    analyzerLogo: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle']
})
